export default __webpack_public_path__ + "media/yo-yo-desktop.821c1f849e76af242026d0ea8a4f8e8f.gif";